// src/utils/formatters.js

/**
 * Format currency values consistently
 * @param {string|number} value - The value to format
 * @param {string} currency - Currency symbol (default: 'UGX')
 * @returns {string} Formatted currency string
 */
export const formatCurrency = (value, currency = 'UGX') => {
  const numValue = parseFloat(value || 0);
  return `${currency} ${numValue.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  })}`;
};

/**
 * Parse string or number to float safely
 * @param {string|number} value - The value to parse
 * @returns {number} Parsed number or 0 if invalid
 */
export const parseNumber = (value) => {
  const parsed = parseFloat(value || 0);
  return isNaN(parsed) ? 0 : parsed;
};

/**
 * Calculate percentage safely
 * @param {number} part - The part value
 * @param {number} total - The total value
 * @returns {number} Percentage (0-100)
 */
export const calculatePercentage = (part, total) => {
  if (!total || total === 0) return 0;
  return Math.round((part / total) * 100);
};